import React from "react";
import { ChevronLeftIcon } from "@heroicons/react/outline";
import EditKuesioner from "./EditKuesioner";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  useRouteMatch,
  useParams
} from "react-router-dom";
import EditKuesionerPilihanGanda from "./features/EditKuesionerPilihanGanda";
import EditKuesionerFile from "./features/EditKuesionerFile";
import EditKuesionerLiklert from "./features/EditKuesionerLiklert";

export default function Edit() {
  let { path } = useRouteMatch();
  let {idKuesioner} = useParams();

  console.log(path)

  let features = [
    { path: `/edit/edit-kuesioner-pilihan-ganda/:idKuesioner`, component: EditKuesionerPilihanGanda },
    { path: `/edit/edit-kuesioner-file/:idKuesioner`, component: EditKuesionerFile },
    { path: `/edit/edit-kuesioner-liklert/:idKuesioner`, component: EditKuesionerLiklert },
  ];
  return (
    <div
      className="w-full flex flex-col dark:text-white pt-16 px-10"
      style={{ minHeight: "100vh" }}
    >
      <div className="w-full">
        <button
          onClick={() => window.history.back()}
          className="flex flex-row items-center"
        >
          <ChevronLeftIcon className="h-4 w-4 mr-2" />
          <p>Kembali</p>
        </button>
      </div>

      <Router>
        <Switch>
          <Route path={path} exact>
            <div className="flex flex-col w-full">
              <EditKuesioner />
            </div>
          </Route>

          {features.map((val, idx) => {
            return (
              <Route key={idx} path={val.path} exact={true}>
                <val.component />
              </Route>
            );
          })}
        </Switch>
      </Router>
    </div>
  );
}
